import Vuex from 'vuex'

const DEFAULT_REQUEST_ERROR = 'Unable to load data'

export default class AuthentigateStore extends Vuex.Store {
  async requestData({
    name,
    makeRequest,
    errorMessage = DEFAULT_REQUEST_ERROR,
    context,
    deps = []
  }) {
    const { dispatch, commit } = context

    await Promise.all(deps.map((dep) => dispatch(dep)))

    const setLoading = `set_${name}Loading`

    commit(setLoading, true)
    await this._vm.$handlingError(
      errorMessage,
      async () => {
        const response = await makeRequest(context)
        commit(`set_${name}`, response.data)
      },
      {
        store: this,
        final: () => commit(setLoading, false)
      }
    )
  }

  get $api() {
    return this._vm.$api
  }
}
